export const faqs: { q: string; a: string[] }[] = [
  {
    q: '¿Necesito saber dibujar o pintar?',
    a: [
      'No. Las actividades utilizan color, líneas, formas, collage, patrones, acuarela y plantillas guiadas. No necesitas experiencia artística.',
    ],
  },
  {
    q: '¿Cuánto tiempo necesito?',
    a: [
      'Puedes empezar con actividades de aproximadamente 5–10 minutos y dedicar más tiempo cuando quieras.',
    ],
  },
  {
    q: '¿Qué materiales necesito?',
    a: [
      'Puedes comenzar con papel, lápiz y colores. Acuarela, pintura, tijeras, revistas y pegamento son opcionales.',
    ],
  },
  {
    q: '¿Tengo que imprimir las 375 páginas?',
    a: ['No. Puedes consultar los PDF digitalmente e imprimir solo las páginas que quieras utilizar.'],
  },
  {
    q: '¿Puedo utilizarlo profesionalmente?',
    a: [
      'Sí. La licencia profesional individual permite utilizar hojas individuales directamente con personas o grupos dentro de tu ámbito profesional. No permite compartir, revender o redistribuir los PDF.',
    ],
  },
  {
    q: '¿Esto es psicoterapia?',
    a: [
      'No. Pausa Propia es una herramienta educativa de bienestar, creatividad, expresión emocional y autoconocimiento inspirada en prácticas creativas y de arteterapia. No sustituye atención médica o psicológica.',
    ],
  },
]
